export default {
  LK: {
    pageTitle: "حساب کاربری",
    subscription: {
      yourSubs: "اشتراک شما",
      plan_1: "رایگان",
      plan_2: "پیشرفته",
      plan_3: "شخصی‌سازی‌شده",
      changePlan: "تغییر طرح",
      activeFor: "فعال تا",
      nextPayment: "پرداخت بعدی",
      accessFor: "دسترسی باز است تا",
      expired: "منقضی شد",
    },
    eduSubs: "اشتراک آموزشی",
    settings: "تنظیمات",
    form: {
      labels: {
        status: "وضعیت",
        spec_med: "تخصص",
        position: "سمت",
        university: "دانشگاه",
      },
      spec_statValues: {
        doctor: "پزشک",
        student: "دانشجو",
        resident: "دستیار",
        spec_med: "کارمند موسسه پزشکی",
      },
      spec_medValues: {
        Obstetrician: "متخصص زایمان",
        "Obstetrician-gynecologist": "متخصص زنان و زایمان",
        Allergist: "آلرژی‌شناس",
        Angiosurgeon: "جراح عروق",
        Andrologist: "اندورولوژیست",
        Anesthetist: "بیهوشی",
        Anesthesiologist: "متخصص بیهوشی",
        Audiologist: "شنوایی‌شناس",
        Bacteriologist: "باکتری‌شناس",
        Venereologist: "متخصص بیماری‌های مقاربتی",
        Vertebrologist: "ستون فقرات‌شناس",
        "Laboratory diagnostics doctor": "پزشک تشخیص آزمایشگاهی",
        "Physiotherapy doctor": "پزشک فیزیوتراپی",
        "Magnetic resonance imaging doctor": "پزشک MRI",
        GP: "پزشک عمومی",
        "Sports medicine doctor": "پزشک پزشکی ورزشی",
        "Ultrasound diagnostic doctor": "پزشک سونوگرافی",
        "Functional diagnostics doctor": "پزشک تشخیص عملکردی",
        Dermatovenerologist: "متخصص پوست و بیماری‌های مقاربتی",
        Dermatologist: "متخصص پوست",
        "Pediatric gastroenterologist": "متخصص گوارش کودکان",
        "Pediatric gynecologist": "متخصص زنان کودکان",
        "Pediatric cardiologist": "متخصص قلب کودکان",
        "Pediatric neurologist": "متخصص مغز و اعصاب کودکان",
        "Child psychiatrist": "روانپزشک کودکان",
        "Pediatric dentist": "دندانپزشک کودکان",
        "Pediatric traumatologist-orthopedist": "ارتوپد و تروما کودکان",
        "Pediatric urologist-andrologist": "اورولوژیست کودکان",
        "Pediatric surgeon": "جراح کودکان",
        "Pediatric endocrinologist": "اندوکرینولوژیست کودکان",
        Nutritionist: "متخصص تغذیه",
        "Other specialty": "تخصص دیگر",
        Immunologist: "ایمونولوژیست",
        "Infectious disease specialist": "متخصص بیماری‌های عفونی",
        Cardiologist: "متخصص قلب",
        Kinesiotherapist: "کینزیوتراپیست",
        "Clinical Pharmacologist": "فارماکولوژیست بالینی",
        Coloproctologist: "کولوپروکتولوژیست",
        Cosmetologist: "متخصص زیبایی",
        "Laboratory assistant": "دستیار آزمایشگاه",
        "Speech therapist": "گفتاردرمانگر",
        "ENT (Otorhinolaryngologist)": "متخصص گوش و حلق و بینی",
        Mammologist: "پستان‌شناس",
        Chiropractor: "کایروپراکتور",
        Masseur: "ماساژور",
        Nurse: "پرستار",
        "Medical brother": "برادر پزشکی",
        "Medical Director": "مدیر پزشکی",
        Mycologist: "قارچ‌شناس",
        "Expert in narcology": "متخصص ترک اعتیاد",
        Neurologist: "متخصص مغز و اعصاب",
        Neurophysiologist: "نوروفیزیولوژیست",
        Neurosurgeon: "جراح مغز و اعصاب",
        Neonatologist: "نوزادشناس",
        Nephrologist: "نفرولوژیست",
        "Oculist (Ophthalmologist)": "چشم‌پزشک",
        Oncologist: "انکولوژیست",
        Orthopedist: "ارتوپد",
        Osteopath: "استئوپات",
        Parasitologist: "پزشک انگل‌شناس",
        Periodontist: "پریودنتیست",
        Pathologist: "پاتولوژیست",
        Teacher: "مدرس",
        Pediatrician: "پزشک اطفال",
        "Plastic surgeon": "جراح پلاستیک",
        Proctologist: "پروکتولوژیست",
        "Occupational pathologist": "پزشک کار",
        Psychiatrist: "روان‌پزشک",
        "Psychiatrist-narcologist": "روانپزشک ترک اعتیاد",
        Psychologist: "روان‌شناس",
        Psychotherapist: "روان‌درمانگر",
        Pulmonologist: "ریه‌شناس",
        Radiolog: "رادیولوژیست",
        Rehabilitologist: "توانبخشی‌گر",
        Reanimatologist: "پزشک احیا",
        Rheumatologist: "روماتولوژیست",
        Radiologist: "رادیولوژیست",
        "Reproductologist (IVF)": "متخصص ناباروری (IVF)",
        Reflexologist: "بازتاب‌درمانگر",
        Sexologist: "سکسولوژیست",
        "Cardiovascular surgeon": "جراح قلب و عروق",
        Somnologist: "خواب‌شناس",
        Dentist: "دندانپزشک",
        "Childrens-dentist": "دندانپزشک کودکان",
        "Dental hygienist": "بهداشت‌کار دهان",
        "Dentist-implantologist": "ایمپلنتولوژیست",
        "Dentist-orthodontist": "ارتودنتیست",
        "Orthopedic dentist": "دندانپزشک ارتوپدی",
        "Dentist-therapist": "دندانپزشک درمانی",
        "Dental surgeon": "جراح دندان",
        Surdolog: "شنوایی‌سنج",
        Therapist: "درمانگر",
        Toxicologist: "سم‌شناس",
        Traumatologist: "تروماشناس",
        "Traumatologist-orthopedist": "تروماشناس ارتوپدی",
        Transplantologist: "پیوندشناس",
        Transfusiologist: "انتقال خون‌شناس",
        Trichologist: "تریکولوژیست",
        Urologist: "اورولوژیست",
        Pharmacist: "داروساز",
        Paramedic: "پزشک اورژانس",
        Physiotherapist: "فیزیوتراپیست",
        Phlebologist: "فلبولوژیست",
        Phoniatrist: "فونیاتریست",
        Phthisiatrician: "سل‌شناس",
        Surgeon: "جراح",
        "Implant surgeon": "جراح ایمپلنت",
        "Maxillofacial surgeon": "جراح فک و صورت",
        Embryologist: "جنین‌شناس",
        Endocrinologist: "اندوکرینولوژیست",
        Endoscopist: "آندوسکوپیست",
        Epidemiologist: "اپیدمیولوژیست",
        Epileptologist: "صرع‌شناس",
      },
    },
  },
};
